import { generateColors } from '@enterprise/core/colors';

import { BASE_HSP_COLOR } from '../common/constants';

export const hspColors = generateColors(BASE_HSP_COLOR);

export const colors = {
  brand: hspColors.solid,
  hsp: hspColors.solid,
  'theme-black': '#6A6E78',
  'theme-blue-gray': '#727D92',
  'theme-blue-green': '#548F8D',
  'theme-blue-priori': '#3182CE',
  'theme-blue-splits': '#4299E1',
  'theme-border': '#E5E4E3',
  'theme-dark-blue': '#324F7C',
  'theme-dark-blue-gray': '#2D3748',
  'theme-dark-gray': '#4A5568',
  'theme-green': '#38A169',
  'theme-light-blue': '#5592D4',
  'theme-light-gray': '#E0E2E8',
  'theme-light-orange': '#FB920F',
  'theme-orange': '#ED8936',
  'theme-purple': '#805AD5',
  'theme-white': '#FCFDFC',
  'theme-yellow': '#EAB308',
} as const;
